import http from '@/utils/http';

const PROXY = '/proxy';

const API = {
  // 根据mac地址获取导航导诊设备
  getScreenInfo (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/poiScreen/queryMac', data, option);
  },
  // 获取app配置信息
  getBaseSettingInfo (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/setting/list', data, option);
  },
  // 获取小程序二维码
  getAppQrcode (data = {}, option = {}) {
    return http.post(PROXY + '/api/weixin/developers/generateQRCord', data, option);
  },
  // 获取百度token
  getBaiduToken (data = {}, option = {}) {
    return http.post(PROXY + '/api/baidu/accessToken', data, option);
  },
  // 获取天气
  getTianqi (data = {}, option = {}) {
    return http.post(PROXY + '/api/weixin/developers/getWeatherInfo', data, option);
  },
  // // 获取天气
  // getTianqi (data = {}, option = {}) {
  //   return http.post(PROXY_TIANQI + '/api', method: 'get', params: data }, option));
  // }

};

export default API;
